import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

export const getCurrentBillCall = async (businessPartner) => interceptor(async () => client.get(urls.getCurrentBill(businessPartner), getHeader()));

export const payBillCall = async (customerId, amount) => interceptor(async () => client.post(urls.payBill(customerId, amount), getHeader()));

export const setPaperBillCall = async (customerId, setPaperFlag) =>
  interceptor(async () => client.post(urls.setPaperBill(customerId, setPaperFlag), getHeader()));

export const getInvoiceByContractAccountIdCall = async (request) =>
  interceptor(async () => client.post(urls.getInvoiceByContractAccountId(), await substituteEncrypted(request), getHeader()));

export const downloadPdfFileCall = async (invoiceNo, contractAccount) =>
  interceptor(async () =>
    client.post(urls.downloadPdfFile(), await substituteEncrypted({ invoiceNumber: invoiceNo, contractAccount: contractAccount }), getHeader())
  );

export const printBillCall = async (invoiceNo) => interceptor(async () => urls.printBill(invoiceNo, getHeader()));
export const getPaymentHistoryCall = async (request) =>
  interceptor(async () => client.post(urls.getPaymentHistory(), await substituteEncrypted(request), getHeader()));

export const getTokenCall = async (postData) => interceptor(async () => client.post(urls.getToken, await substituteEncrypted(postData), getHeader()));

export const getPaymentProcessStatusCall = async (sessionId, revealId) =>
  interceptor(async () => {
    const { sessionId: encryptedSessionId } = await substituteEncrypted({ sessionId });
    const payload = {
      sessionId: encryptedSessionId,
      ...(revealId && { revealId }),
    };
    return client.post(urls.getPaymentProcessStatus(), payload, getHeader());
  });

export const getQuickBillCall = async (contractAccountNumber) =>
  interceptor(async () => client.post(urls.getQuickBill(), await substituteEncrypted({ contractAccount: contractAccountNumber }), getHeader()));

export const getCountryCodeCall = async (request) =>
  interceptor(async () => client.post(urls.fetchCountryCodesUrl, await substituteEncrypted(request), getHeader()));
